import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectShowDocumentPending = createSelector(
  [(store: RootState) => store.documentShow.showDocumentPendingModal],
  (data) => data
);
